// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"NavigationItem_activeTab__3QZKD","activeSidebar":"NavigationItem_activeSidebar__1-teC"};